import { Container } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { ArrowForward } from "@material-ui/icons";
import { ActivityLogsNewValues } from "@saleor/permissionGroups/utils/activityLogsNewValues";
import { ActivityLogsOldValues } from "@saleor/permissionGroups/utils/activityLogsOldValues";
import moment from "moment-timezone";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    arrow: {
      color: "#002972",
      marginRight: "6px"
    },
    bullet: {
      backgroundColor: "#002972",
      borderRadius: "50%",
      height: "4px",
      width: "4px"
    },
    card: {
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(3),
      position: "relative"
    },
    cardContent: {
      "&:last-child": {
        padding: 16
      },
      boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.05)",
      display: "flex",
      justifyContent: "space-between"
    },
    date: {
      color: "#494E56",
      fontSize: "16px",
      fontWeight: 600
    },
    dot: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "100%",
      height: 10,
      left: -29.5,
      position: "absolute",
      top: 10,
      width: 10
    },
    newValueDate: {
      fontSize: "16px",
      fontWeight: 600
    },
    oldValueDate: {
      color: "#747C8C",
      fontSize: "16px",
      fontWeight: 400
    },
    root: {
      position: "relative"
    },
    status: {
      color: "#002972",
      fontSize: "16px",
      fontWeight: 600
    },
    userEmail: {
      color: "#494E56",
      fontSize: "14px",
      fontWeight: 400
    },
    userTypeCode: {
      color: "#002972",
      fontSize: "16px",
      fontWeight: 600
    }
  }),
  { name: "TimelineOldValues" }
);

interface TimelineOldValuesProps {
  date: string;
  user: {
    email: string;
  };
  newValues: ActivityLogsNewValues;
  oldValues: ActivityLogsOldValues;
}

const dateFormat = value => {
  const date = moment(value);
  return date.format("h:mm:ssA");
};

export const TimelineOldValues: React.FC<TimelineOldValuesProps> = props => {
  const { date, user, newValues, oldValues } = props;

  const classes = useStyles(props);

  const newValueMFAEnabledDate =
    newValues?.mfa_enabled_date === null ? "Disabled" : "Enabled";
  const oldValueMFAEnabledDate =
    oldValues?.mfa_enabled_date === null ? "Disabled" : "Enabled";

  return (
    <div className={classes.root}>
      <span className={classes.dot} />
      <Container>
        <div style={{ display: "flex", gap: "20px" }}>
          <div>
            <Typography className={classes.date}>{dateFormat(date)}</Typography>
          </div>
          <div style={{ alignItems: "center", gap: "20px" }}>
            <div>
              <Typography className={classes.userTypeCode}>
                {newValues?.name}
              </Typography>
            </div>
            <div>
              <Typography className={classes.userEmail}>
                {"<updated by: " + user?.email + ">"}
              </Typography>
            </div>
          </div>
        </div>
        <div style={{ marginLeft: "75px", marginTop: "20px" }}>
          <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
              <div
                style={{ alignItems: "center", display: "flex", gap: "10px" }}
              >
                <span className={classes.bullet} />
                <Typography className={classes.status}>Status:</Typography>
                <Typography className={classes.oldValueDate}>
                  {oldValueMFAEnabledDate}
                </Typography>
                <ArrowForward className={classes.arrow} />
                <Typography className={classes.newValueDate}>
                  {newValueMFAEnabledDate}
                </Typography>
              </div>
            </CardContent>
          </Card>
        </div>
      </Container>
    </div>
  );
};

TimelineOldValues.displayName = "TimelineOldValues";

export default TimelineOldValues;
